import { cn } from '@lyearn/style';
import { SelectSize, Stack, Typography } from '@lyearn/ui';

import { FormSelectOption } from './types';

const SIZE_CONFIG = {
  large: { icon: 'w-22 h-22', label: 'body-short-01' },
  medium: { icon: 'w-20 h-20', label: 'body-short-02' },
} as const;

interface Props<T> {
  className?: string;
  option: FormSelectOption<T>;
  size: SelectSize;
}

export const SelectValueRenderer = <T,>(props: Props<T>) => {
  const { className, option, size } = props;
  const { Icon, label } = option;
  const sizeConfig = SIZE_CONFIG[size];

  return (
    <Stack alignItems="center" className={cn('flex-1', className)} gapX={8}>
      {Icon ? <Icon className={cn('shrink-0 text-icon-primary', sizeConfig.icon)} /> : null}
      <Typography className="truncate" color="text-text-primary" variant={sizeConfig.label}>
        {label}
      </Typography>
    </Stack>
  );
};

export const renderMediumSelectValue = <T,>(option: FormSelectOption<T>) => (
  <SelectValueRenderer option={option} size="medium" />
);

export const renderLargeSelectValue = <T,>(option: FormSelectOption<T>) => (
  <SelectValueRenderer option={option} size="large" />
);
